<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Allerjenler <button class="btn btn-primary" (click)="openSaveModal()">+ Yeni Ekle</button>
              </ng-container>
              <ng-container mCardBody>
              
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                   
                    <th>INCI Adı</th>
                    <th>CAS</th>
                    <th>EINECS/ELICS</th>
                    <th>Fonksiyon</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                  <tr *ngFor="let h of filteredhammeddeler">
                   
                    <td>{{h.inciName}}</td>
                    <td>{{h.cas}}</td>
                    <td>{{h.einecs}}</td>
                    <td>{{h.function}}</td>
                    <td>
                     
                      <i class="la la-remove danger" (click)="delete(h.id)" style="cursor: pointer;"></i>
                    </td>
                  </tr>
                 
                </table>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
